import React from 'react';
import { Link } from 'react-router-dom';

function NewsSection({ newsItems }) {
  return (
    <section className="py-12 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white">Latest Team News</h2>
          <Link to="/news" className="text-yellow-400 hover:text-yellow-300 font-medium">
            View All News →
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsItems.map((item) => (
            <Link
              key={item._id}
              to={`/news/${item.slug.current}`}
              className="bg-gray-900 rounded-lg overflow-hidden border border-gray-800 hover:border-yellow-700 transition-all"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    // Fallback if image fails to load
                    e.currentTarget.src = '/article-placeholder.jpg';
                  }}
                />
              </div>
              <div className="p-6">
                <div className="text-yellow-500 text-sm mb-2">{item.date}</div>
                <h3 className="text-xl font-bold text-white mb-2">{item.title}</h3>
                <p className="text-gray-400 mb-4">{item.excerpt}</p>
                <span className="text-yellow-400 hover:text-yellow-300 font-medium">
                  Read More →
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NewsSection;
